module.exports = __webpack_public_path__ + "static/media/techThumbnail.033e6e7d.jpg";